import React, { ReactElement, useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { Range as InputRange, getTrackBackground } from 'react-range';

import './range-slider-multi.scss';

export interface Range {
    max: number;
    min: number;
}

interface RangeSliderMultiProps {
    valuesRange: Range;
    step?: number;
    minValue: number;
    maxValue: number;
    onChange: (value: Range) => void;
    onChangeComplete: (value: Range) => void;
    ariaLabelledby?: string;
}

const RangeSliderMulti: React.FC<RangeSliderMultiProps> = ({
    valuesRange,
    minValue,
    maxValue,
    step = 1,
    onChange,
    onChangeComplete,
    ariaLabelledby
}): ReactElement => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    const values = [valuesRange.min, valuesRange.max];

    return (
        <div className="range-slider-multi">
            <InputRange
                values={values}
                step={step}
                min={minValue}
                max={maxValue}
                onChange={(value: number[]): void => onChange({ min: value[0], max: value[1] })}
                onFinalChange={(value: number[]): void => onChangeComplete({ min: value[0], max: value[1] })}
                renderTrack={({ props, children }): ReactElement => (
                    <div
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        style={{
                            ...props.style,
                            height: '36px',
                            display: 'flex',
                            width: '100%'
                        }}
                    >
                        <div
                            id={ariaLabelledby}
                            ref={props.ref}
                            style={{
                                height: '4px',
                                width: '100%',
                                borderRadius: '0px',
                                background: getTrackBackground({
                                    values,
                                    colors: ['#d3d7de', '#084690', '#d3d7de'],
                                    min: minValue,
                                    max: maxValue
                                }),
                                alignSelf: 'center'
                            }}
                        >
                            {children}
                        </div>
                    </div>
                )}
                renderThumb={({ props, isDragged }): ReactElement => (
                    <div
                        {...props}
                        aria-labelledby={ariaLabelledby}
                        style={{
                            ...props.style,
                            height: isMobile ? '30px' : '20px',
                            width: isMobile ? '30px' : '20px',
                            borderRadius: '50%',
                            backgroundColor: isDragged ? '#053670' : '#084690',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    />
                )}
            />
        </div>
    );
};

export default RangeSliderMulti;
